<template>
  <div id="home">
    <div class="main">
      <a-row>
        <a-col :xs="0" :sm="0" :md="2" :lg="7" :xl="7">
        </a-col>
        <a-col :xs="24" :sm="24" :md="20" :lg="10" :xl="10">
          <div class="bg">
            <div class="row-1">
              <a-row type="flex">
                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <a href="http://www.lovereadingbooks.com/2021/pinpai" target="_blank"><img src="../assets/img/pinpai.png" /></a>
                </a-col>
                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <a href="http://www.lovereadingbooks.com/2021/diandubi" target="_blank"><img src="../assets/img/piyopen.png" /></a>
                </a-col>
                 <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <a href="http://www.lovereadingbooks.com/2021/qimengguan" target="_blank"><img src="../assets/img/qimeng.png" /></a>
                </a-col>
              </a-row>
            </div>
            <div class="row-2">
              <div class="row-2-1"> </div>
              <div class="row-2-1"> </div>
              <div class="row-2-1">
                <a href="http://www.lovereadingbooks.com/2021/huibenguan" target="_blank">
                <img src="../assets/img/huiben.png" width="70" height="70" /></a> </div>
            </div>
            <div class="row-3">
              <a-row type="flex">
                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <a href="http://www.lovereadingbooks.com/2021/yingyuguan" target="_blank"><img src="../assets/img/yingyu.png" width="70" height="70" /></a>
                </a-col>
                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <a href="http://www.lovereadingbooks.com/2021/wenxueguan" target="_blank"><img src="../assets/img/wenxue.png" width="70" height="70" /></a>
                </a-col>
                 <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                   <a href="http://www.lovereadingbooks.com/2021/kepuguan" target="_blank"> <img src="../assets/img/kepu.png" width="70" height="70" /></a>
                </a-col>
              </a-row>        
            </div>
          </div>
        </a-col>
        <a-col :xs="0" :sm="0" :md="2" :lg="7" :xl="7">
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
// import List from '@/components/list/List.vue';
import bgImg from "@/assets/img/category@x1.jpg";
// import categoryX2 from "@/assets/img/category@x2.jpg";

export default {
  name: "App",
  components: {
    // List
  },
  data() {
    return {
      bgImg,
      isMobiled: false,
      // categoryX2
    };
  },
  created() {
    var userAgent = navigator["userAgent"]["toLowerCase"]();
    var html5keys = [
      "iphone",
      "ipad",
      "ipod",
      "symbianos",
      "ios",
      "android",
      "bb",
      "playbook",
    ];
    var isHTML5 = false;
    for (var i = 0; i < html5keys.length; i++) {
      if (userAgent["indexOf"](html5keys[i]) > 0) isHTML5 = true;
    }
    if (isHTML5) {
      this.isMobiled = true;
    } else {
      this.isMobiled = false;
    }
    console.log(this.isMobiled);
  },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
}

#home {
  width: 100%;
  height: auto;
  min-height: 100%;
}

.main {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh;
}

@media (min-width: 992px) {
  .bg {
    width: 625px;
    background-repeat: no-repeat;
    background-image: url("../assets/img/category@x1.jpg");
    background-position: center center;
    width: auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
  }

  .bg .row-1 img, .bg .row-2 img, .bg .row-3 img {
    width: 180px;
    height: 180px;
  }

  .bg .row-1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 30px;
    padding: 0 120px;
    text-align: left;
  }

  .bg .row-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 40px;
    padding: 0 120px;
    text-align: left;
  }

  .bg .row-2 .row-2-1, .bg .row-2 .row-2-2 {
    width: 180px;
    height: 180px;
  }

  .bg .row-3 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 30px;
    padding: 0 120px;
    text-align: left;
  }
}


/* ipad横屏 */
@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : landscape){
  .bg {
    background-repeat: no-repeat;
    background-image: url("../assets/img/bgc@small.jpg");
    background-position: 40% top;
    width: auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
  }

  .bg .row-1 img, .bg .row-2 img, .bg .row-3 img {
    width: 120px;
    height: 120px;
  }

  .bg .row-1 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 40px;
    padding: 0 0px;
  }

  .bg .row-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 50px;
    padding: 0 0px;
    text-align: left;
  }

  .bg .row-2 .row-2-1, .bg .row-2 .row-2-2 {
    width: 180px;
    height: 180px;
  }

  .bg .row-3 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 10px;
    padding: 0 0px;
    text-align: left;
  }
}

/* ipad竖屏 */
@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : portrait){
  .bg {
    background-repeat: no-repeat;
    background-image: url("../assets/img/category@x1.jpg");
    background-position: 40% top;
    width: auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
  }

  .bg .row-1 img, .bg .row-2 img, .bg .row-3 img {
    width: 150px;
    height: 150px;
  }

  .bg .row-1 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 40px;
    padding: 0 0px;
  }

  .bg .row-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 80px;
    padding: 0 0px;
    text-align: left;
  }

  .bg .row-2 .row-2-1, .bg .row-2 .row-2-2 {
    width: 150px;
    height: 150px;
  }

  .bg .row-3 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 60px;
    padding: 0 0px;
    text-align: left;
  }
}

@media (max-width: 767px) {
  .bg {
    background-repeat: no-repeat;
    background-image: url("../assets/img/bgc@small.jpg");
    background-position: 40% top;
    width: auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
  }

  .bg .row-1 img, .bg .row-2 img, .bg .row-3 img {
    width: 120px;
    height: 120px;
  }

  .bg .row-1 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 40px;
    padding: 0 0px;
  }

  .bg .row-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 50px;
    padding: 0 0px;
    text-align: left;
  }

  .bg .row-2 .row-2-1, .bg .row-2 .row-2-2 {
    width: 120px;
    height: 120px;
  }

  .bg .row-3 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 40px;
    padding: 0 0px;
    text-align: left;
  }
}
</style>
